import React from 'react';

function Home({ onLoginClick }) {
  return (
    <main style={{ minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h2>Welcome to LinkBridge</h2>
      <div style={{ margin: '40px 0' }}>
        {/* Login Option */}
        <button style={{ padding: '10px 30px', fontSize: '1rem' }} onClick={onLoginClick}>Login</button>
      </div>
      {/* Space for future content */}
    </main>
  );
}

export default Home;
